import { FC } from "react";
import { CheckboxField } from "@sainsburys-tech/luna-form";
import { VolumetricFormInputs } from "../../Interfaces/Product/IProductFormField";
import TooltipComp from "./TooltipComp";
import { UI_CONSTANTS } from "../../Constants/constants";

interface ApprovedExceptionCheckboxProps {
    checked: boolean | undefined;
    onChange: (e: any, event: string, target: string, isCheckBox: boolean) => void;
}

const ApprovedExceptionCheckbox: FC<ApprovedExceptionCheckboxProps> = ({ checked, onChange }) => {
    return (
        <div className="checkbox-contain" style={{ display: "flex"}}>
            <div style={{ width: "100%" }}>
                <CheckboxField
                    label=""
                    name={'overridenValidations'}
                    outlined
                    options={[
                        {
                            value: true,
                            label: VolumetricFormInputs.ApprovedException,
                        },
                    ]}
                    defaultChecked={checked}
                    onClick={(e: any) => {
                        onChange(e, "", "", true);
                    }}
                    fullWidth
                />
            </div>
            <div style={{ position: "absolute", right: 5}}>
                <TooltipComp
                    tooltip={UI_CONSTANTS.APPROVED_EXCEPTIONS_INFO_MESSAGE}
                    position="top"
                    messageClass="tooltip-minwidth-30em"
                    tooltipClass="ln-tooltip-info"
                />
            </div>
        </div>
    );
};

export default ApprovedExceptionCheckbox;